<a class="back-btn" (click)="goBack()">{{ 'general.back' | translate }}</a>
<!-- Title -->
<p>{{ '2fa.contact.p' | translate }}</p>
<!-- Existing phone -->
<div>
  <p>
    <span class="icon-i-phone"></span>
    <span> {{ '2fa.contact.callUs' | translate }} <span [innerHtml]="'contact.phoneNumber' | translate"></span>. </span>
  </p>
  <p>
    <span class="icon-i-email"></span>
    <span> {{ '2fa.contact.sendUsEmail' | translate }} <a target="_blank" href="mailto:customers@inyova.ch">customers&#64;inyova.ch</a>. </span>
  </p>
</div>
